import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { PromoListComponent } from './list/promo-list.component';
import { PromoCreateComponent } from './create/promo-create.component';
import { PromoUpdateComponent } from './update/promo-update.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: PromoListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'promo.read'
            }
          }
        ]
      },
      {
        path: 'create',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Add Promo'
        },
        children: [
          {
            path: '',
            component: PromoCreateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'promo.create'
            }
          }
        ]
      },
      {
        path: ':id/update',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Update Promo'
        },
        children: [
          {
            path: '',
            component: PromoUpdateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'promo.update'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PromoRoutingModule {}
